// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '동성제약',
  targetSheetName: '동성제약요율표',
  headerRowIndex: 2,
  headerRowCount: 1,
  dataStartRowIndex: 3,
  columnMapping: {
    drugCode: '보험청구코드',
    drugName: '제품명',
    price: '약가',
    commissionRate: '수수료율',
    commissionNote: '비고',
  },
  requiredHeaders: [
    'WAP분류',
    '분류번호',
    '성분명',
    '제품명',
    '약가',
    '수수료율',
    '프로모션 요율',
    '구간적용',
    '보험청구코드',
    '비고',
    '생동여부',
    '자사여부',
  ],
});
